import { useState } from 'react';
import { useDispatch } from 'react-redux';

import FormInput from '../form-input/form-input.component';
import Button, { BUTTON_TYPE_CLASSES } from '../button/button.component';


import { googleSignInStart, emailSignInStart } from '../../store/user/user-action';

import './sign-in-form.styles.scss';


const defaultformFields = {
    email: '',
    password: '',
}

console.log(defaultformFields);


const SignInForm = () => {
    const dispatch = useDispatch();
    const [formFields, setformFields] = useState(defaultformFields);
    const { email, password } = formFields;

    const resetFormFields = () => {
        setformFields(defaultformFields);
    };

    const signInWithGoogle = async () => {
        dispatch(googleSignInStart());
    };

    const handleSubmit = async (event) => {
        event.preventDefault();


        try {
            dispatch(emailSignInStart(email, password));
            resetFormFields();
        } catch (error) {
            console.log('user sign in failed', error);
        };
    };

    const handleChange = (event) => {
        const {name, value} = event.target;

        setformFields({...formFields, [name]: value});
    };

    return (
        <div className='sign-up-container'>
            <h2>Already have an account?</h2>
            <span>Sign in with email and password</span>
            <form onSubmit={handleSubmit}>

                <FormInput 
                label='Email'
                type='email' 
                required 
                onChange={handleChange} 
                name='email' 
                value={email} />

                <FormInput 
                label='Password'
                type='password' 
                required 
                onChange={handleChange} 
                name='password' 
                value={password} />

                <div className='buttons-container'>
                <Button type='submit'>Sign In</Button>
                <Button type='button' buttonType={BUTTON_TYPE_CLASSES.google} onClick={signInWithGoogle}>Google sign in</Button>
                </div>
            </form>
        </div>
    )
};

export default SignInForm;